import React, { useState, useEffect } from 'react';

const FeatureSection = () => {
    const [data, setData] = useState({
        heading: "Why Choose MobiCloud",
        subheading: "In a World of Change, Choose MobiCloud",
        description: "We differentiate ourselves by delivering innovative solutions that not only meet your immediate needs but also anticipate and adapt to the dynamic challenges of the future.",
        features: [
            {
                icon: "fas fa-rocket",
                title: "Innovation Meets Impact",
                description: "Cutting-edge technology solutions that drive real business transformation and measurable results."
            },
            {
                icon: "fas fa-globe",
                title: "Global Expertise",
                description: "World-class team with deep expertise across cloud, AI, mobile, and digital transformation domains."
            },
            {
                icon: "fas fa-shield-alt",
                title: "Enterprise Security",
                description: "Bank-grade security protocols and compliance standards to protect your business data and applications."
            },
            {
                icon: "fas fa-clock",
                title: "24/7 Support",
                description: "Round-the-clock technical support and maintenance to ensure your systems run smoothly."
            },
            {
                icon: "fas fa-chart-line",
                title: "Scalable Solutions",
                description: "Flexible and scalable architecture that grows with your business needs and requirements."
            },
            {
                icon: "fas fa-handshake",
                title: "Partnership Approach",
                description: "Long-term partnership mindset focused on your success and continuous improvement."
            }
        ]
    });

    return (
        <section className="section feature-area bg-white overflow-hidden ptb_100">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-8">
                        <div className="section-heading text-center mb-5">
                            <h2 className="text-capitalize mb-4">{data.heading}</h2>
                            <h4 className="text-primary mb-3">{data.subheading}</h4>
                            <p className="text-muted fs-5">{data.description}</p>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {data.features.map((feature, idx) => (
                        <div key={idx} className="col-12 col-md-6 col-lg-4 mb-4">
                            <div className="single-feature text-center p-4 h-100">
                                <div className="feature-icon mb-4">
                                    <div className="icon-box bg-primary text-white rounded-circle d-inline-flex align-items-center justify-content-center" style={{width: '70px', height: '70px'}}>
                                        <i className={`${feature.icon} fa-2x`}></i>
                                    </div>
                                </div>
                                <div className="feature-text">
                                    <h5 className="mb-3">{feature.title}</h5>
                                    <p className="text-muted">{feature.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeatureSection; 